export default "__VITE_ASSET__DmKoRV9O__";